import React from "react";
import { ReactComponent as NotificationIcon } from "./../../assets/svg/notification.svg";

// Components
import { Popover } from "antd";

export const NotificationModal = () => {
  const notifications = [];

  const notificationContent = (
    <div className="notification-popover">
      <div>
        {notifications.map((notification) => {
          return (
            <div className="notification-popover-details">
              <div className="notification-bullet-point" />
              <div className="notification-detail">
                <div className="notification-title">{notification.title}</div>
                <div className="notification-text">{notification.text}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <Popover
      placement="bottomRight"
      content={notificationContent}
      title="Notifications"
      trigger="click"
    >
      <button className="notification-button">
        <NotificationIcon />
      </button>
    </Popover>
  );
};
